export const buildGenericRequest = (formData, props) => {
  const [expiryMonth, expiryYear] = formData.cardExpiryDate.split(" / ");
  const request = {
    fleetId: props.fleetId,
    userId: props.userId ?? props.i,
    cardNumber: formData.cardNumber.replace(/\s+/g, ""),
    expiredDate: `${expiryMonth}/20${expiryYear}`,
    cvv: formData.cardCVC,
    cardHolder: formData.cardHolder,
    name: formData.cardHolder,
  };

  if (props.tranId) {
    request.transactionId = props.tranId;
  }

  if (formData.billingAddress?.trim()) {
    request.street = formData.billingAddress.trim();
  }
  if (formData.billingCity?.trim()) {
    request.city = formData.billingCity.trim();
  }
  if (formData.billingState?.trim()) {
    request.state = formData.billingState.trim();
  }
  if (formData.billingPostal?.trim()) {
    request.postalCode = formData.billingPostal.trim();
  }
  if (formData.billingCountry?.trim()) {
    request.country = formData.billingCountry.trim();
  }
  if (formData.billingEmail?.trim()) {
    request.email = formData.billingEmail.trim();
    request.billingEmail = formData.billingEmail.trim();
  }
  if (formData.billingPhone?.trim()) {
    request.phone = formData.billingPhone.trim();
    request.creditPhone = formData.billingPhone.trim();
  }

  return request;
};

export const getGenericSuccessUrl = (props) =>
  props.u ?? props.returnUrl ?? null;

export const isRedirectEnabled = (redirect) =>
  redirect === true || redirect === "true";

export const getGenericActionRedirectUrl = (props) => {
  if (!isRedirectEnabled(props.redirect)) {
    return null;
  }
  const action = typeof props.action === "string" ? props.action.trim() : "";
  if (!action) {
    return null;
  }
  try {
    return decodeURIComponent(action);
  } catch (e) {
    return action;
  }
};
